export default __webpack_public_path__ + "static/media/Reflection.bcc0ea21.png";